import { useMemo } from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { CLP_FORMATTER } from "../../../utils/currency";

const formatearFecha = (rowData) => {
  const fecha = new Date(rowData.fecha);
  return Number.isNaN(fecha.getTime()) ? "-" : fecha.toLocaleDateString("es-CL");
};

const formatearMonto = (rowData) => CLP_FORMATTER.format(Number(rowData.saldo || 0));

const getEstado = (rowData) => {
  if (rowData.atraso > 0) return <Tag severity="danger" value="Vencido" />;
  if (rowData.atraso === 0) return <Tag severity="warning" value="Próximo a vencer" />;
  return <Tag severity="success" value="Vigente" />;
};

const COLUMNS = [
  { field: "tipo", header: "Tipo" },
  { field: "numero", header: "N° Documento" },
  { field: "vendedor", header: "Vendedor", body: (r) => r.vendedor?.descripcion || "-" },
  { field: "fecha", header: "Fecha", body: formatearFecha },
  { field: "saldo", header: "Monto", body: formatearMonto },
  { field: "atraso", header: "Estado", body: getEstado },
];

const AccountBalance = ({ clientInfo, deudaCliente = [], isLoadingClientInfo }) => {
  const accountSummary = useMemo(() => {
    if (!clientInfo) return [];
    const credito = Number(clientInfo.credito) || 0;
    const saldoOrden = Number(clientInfo.saldoOrden) || 0;
    const utilizado = credito - saldoOrden;
    const vencidas = (deudaCliente || []).filter((d) => Number(d.atraso) > 0);
    const saldoVencido = vencidas.reduce((acc, d) => acc + Number(d.saldo || 0), 0);
    const estado = !deudaCliente || deudaCliente.length === 0
      ? "Sin datos"
      : vencidas.length > 0
        ? "Con deuda"
        : "Al día";
    return [
      { label: "Estado", value: estado },
      { label: "Línea de crédito", value: Number.isFinite(credito) ? CLP_FORMATTER.format(credito) : "$0" },
      { label: "Monto utilizado", value: Number.isFinite(utilizado) ? CLP_FORMATTER.format(utilizado) : "$0" },
      { label: "Saldo vencido", value: CLP_FORMATTER.format(saldoVencido) },
    ];
  }, [clientInfo, deudaCliente]);

  return (
    <div className="flex flex-column gap-3">
      <Card title="Estado de cuenta">
        {isLoadingClientInfo ? (
          <p className="admin-text-sm">Cargando información...</p>
        ) : (
          <div className="grid">
            {accountSummary.map((item) => (
              <div key={item.label} className="col-12 md:col-6 lg:col-3">
                <Card>
                  <p className="m-0 admin-text-sm">{item.label}</p>
                  <strong className="admin-text-base">{item.value}</strong>
                </Card>
              </div>
            ))}
          </div>
        )}
      </Card>
      <Card title="Deuda del Cliente">
        <DataTable
          value={deudaCliente}
          emptyMessage="Sin documentos"
          stripedRows
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords}"
          responsiveLayout="scroll"
        >
          {COLUMNS.map((col) => (
            <Column key={col.field} field={col.field} header={col.header} body={col.body} />
          ))}
        </DataTable>
      </Card>
    </div>
  );
};

export default AccountBalance;
